import { Link } from "react-router-dom";

export const NotFound = () => (
    <main className="relative flex min-h-[100svh] flex-col items-center justify-center px-6 text-center">
        <span
            aria-hidden="true"
            className="pointer-events-none absolute left-1/2 top-1/2 -z-10 -translate-x-1/2 -translate-y-1/2 select-none font-deva text-[46vw] leading-none text-ink opacity-[0.03]"
        >
            पत्र
        </span>
        <p className="mb-6 font-sans text-xs tracking-[0.3em] uppercase text-sepia">404</p>
        <h1 className="mb-8 font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl md:text-6xl">
            This letter went astray
        </h1>
        <p className="mx-auto max-w-[52ch] font-serif text-xl leading-[1.75] text-ink/90">
            Some did. Before tracking numbers, a lost letter was simply gone, and you never learned
            whether it was the road, the ship, or the reader who failed you.
        </p>
        <Link
            to="/"
            data-testid="back-home-link"
            className="mt-12 inline-flex items-center gap-2 font-sans text-sm tracking-[0.15em] uppercase text-wax transition-opacity hover:opacity-70"
        >
            Back to the beginning →
        </Link>
    </main>
);
